import cn from 'classnames'
import React from 'react'

import InlineNotification from 'components/InlineNotification'
import { inject } from 'helpers/mobx'
import { getGenderText } from 'helpers/seo'
import { unescapeAndDecode } from 'helpers/text'
import { TranslateFnType } from 'store'

import * as styles from './styles.module.scss'

interface IGenderRedirectNotificationProps {
  searchTerm: string
  redirectionStatus: string | undefined
  t: TranslateFnType
}

interface IGenderRedirectNotificationState {
  isVisible: boolean
}

class GenderRedirectNotification extends React.Component<
  IGenderRedirectNotificationProps,
  IGenderRedirectNotificationState
> {
  state = {
    isVisible: true,
  }

  hide = () => {
    this.setState({
      isVisible: false,
    })
  }

  render() {
    const { searchTerm, redirectionStatus, t } = this.props

    if (!redirectionStatus || !this.state.isVisible) {
      return null
    }

    const containerClass = cn(styles.container)

    const redirectText = t(
      'Deine Suche nach "{{- searchTerm}}" ergab leider keinen Treffer {{genderFrom}}. Hier findest du Ergebnisse {{genderTo}}.',
      {
        genderFrom: getGenderText({
          gender: redirectionStatus.split('-')[0],
          t,
        }),
        genderTo: getGenderText({
          gender: redirectionStatus.split('-')[1],
          t,
        }),
        searchTerm: unescapeAndDecode(searchTerm),
      },
    )

    return (
      <div className={containerClass}>
        <InlineNotification
          show={true}
          type={'warning'}
          text={redirectText}
          onHide={this.hide}
          isCloseable={true}
          avoidDangerouslySetInnerHTML={true}
        />
      </div>
    )
  }
}

export default inject(stores => ({
  t: stores.t,
}))(GenderRedirectNotification)
